import { useLoaderData } from "react-router-dom";
import { ListingBrowseView } from "~/components/ListingBrowse";
import type { ListingBrowsePageLoaderResult } from "~/types/listing";

export const UnitListPage: React.FC = () => {
  const loaderData = useLoaderData() as ListingBrowsePageLoaderResult;

  return (
    <section style={{ marginTop: "2rem" }}>
      <ListingBrowseView loaderData={loaderData} />
    </section>
  );
};
